export default "__VITE_ASSET__DvvPU5MU__"